import I18n from 'I18n';
import NonEnrollmentDiagnosisPanelWrapper from 'automation-ui-management/components/panels/NonEnrollmentDiagnosisPanelWrapper';
import { TroubleShootIssuesPanel } from 'automation-ui-canvas/components/alerts/TroubleshootIssuesPanel';
import { useCallback, useMemo } from 'react';
import { GET_FLOW_HEALTH_INSIGHTS } from 'automation-ui-canvas/queries/insightsQueries';
import { useQuery } from 'data-fetching-client';
import ShortcutsHelpPanel from 'automation-ui-canvas/components/flow-header/menu-bar/ShortcutsHelpPanel';
import { jsx as _jsx } from "react/jsx-runtime";
export const KnowledgeBaseOption = {
  id: 'knowledge',
  getLabel: () => I18n.text('automation.editorMenuBar.options.knowledge'),
  external: true,
  onClick: () => {
    window.open('https://knowledge.hubspot.com/automation/topics#workflows', '_blank');
  }
};
export const useIssuesOption = ({
  flow
}) => {
  const {
    data
  } = useQuery(GET_FLOW_HEALTH_INSIGHTS, {
    variables: {
      flowId: flow.flowId
    }
  });
  const showBadge = data && (data.flowHealthInsights.executionErrors.length > 0 || data.flowHealthInsights.enrollmentErrors.length > 0);
  const ModalComponent = useCallback(({
    onClose
  }) => /*#__PURE__*/_jsx(TroubleShootIssuesPanel, {
    onClose: onClose,
    flow: flow
  }), [flow]);
  return useMemo(() => ({
    id: 'issues',
    getLabel: () => I18n.text('automation.editorMenuBar.options.issues'),
    badge: showBadge ? 'notification' : undefined,
    ModalComponent
  }), [showBadge, ModalComponent]);
};
export const EnrollmentIssuesOption = {
  id: 'enrollmentIssues',
  getLabel: () => I18n.text('automation.editorMenuBar.options.enrollmentIssues'),
  onClick: () => {},
  ModalComponent: ({
    flow,
    onClose
  }) => {
    return /*#__PURE__*/_jsx(NonEnrollmentDiagnosisPanelWrapper, {
      flowId: flow.flowId,
      flowObjectTypeId: flow.objectTypeId,
      onClose: onClose
    });
  }
};
export const ShortcutsHelpOption = {
  id: 'helpShortcuts',
  getLabel: () => I18n.text('automation.editorMenuBar.options.helpShortcuts'),
  shortcut: {
    key: '/',
    control: true
  },
  ModalComponent: ShortcutsHelpPanel
};
export const HELP_OPTION_ID = 'help';
export const useHelpOption = ({
  flow
}) => {
  const IssuesOption = useIssuesOption({
    flow
  });
  return useMemo(() => ({
    id: HELP_OPTION_ID,
    getLabel: () => I18n.text('automation.editorMenuBar.menus.help'),
    options: [[KnowledgeBaseOption], [IssuesOption, EnrollmentIssuesOption, ShortcutsHelpOption]]
  }), [IssuesOption]);
};
export const RevisionHelpOption = {
  id: HELP_OPTION_ID,
  getLabel: () => I18n.text('automation.editorMenuBar.menus.help'),
  options: [[KnowledgeBaseOption, ShortcutsHelpOption]]
};